import { Controller } from "@hotwired/stimulus"

import { showLazyFrameFailure } from "../lib/lazy_frame.mjs"

// Point a lazy turbo frame's fetch-failure events here so a failed or timed-out
// request replaces the frame's loading placeholder with an error message instead
// of leaving it loading forever.
export default class extends Controller {
  static targets = ["status"]

  showError(event) {
    // A successful load replaces the placeholder (and this target) with real content.
    if (!this.hasStatusTarget) return

    event.preventDefault()
    showLazyFrameFailure(this.statusTarget)
  }
}
